import { History, Menu, X } from "lucide-react";

import { Logo } from "./Logo";
import { MobileHeaderProps } from "./types";

export const MobileHeader = ({
  mobileMenuOpen,
  toggleMobileMenu,
  collapsed,
  chatHistoryOpen,
  toggleChatHistory,
  showChatHistory = false,
}: MobileHeaderProps) => {
  const isAnyMenuOpen = mobileMenuOpen || chatHistoryOpen;

  return (
    <header
      className={`md:hidden fixed top-0 left-0 right-0 z-50 backdrop-blur-lg h-16 ${isAnyMenuOpen ? "bg-background" : "bg-background/80 border-b border-border"}`}
    >
      <div className="h-full flex items-center justify-between px-4">
        <Logo collapsed={collapsed} />

        <div className="flex items-center gap-4">
          {/* Chat History Button - only show when on chat page and not in menu */}
          {showChatHistory && !mobileMenuOpen && (
            <button
              onClick={toggleChatHistory}
              className="flex items-center gap-1.5 text-foreground"
              aria-label="Chat history"
            >
              {chatHistoryOpen ? (
                <X className="h-5 w-5" />
              ) : (
                <>
                  <History className="h-4 w-4" />
                  <span className="text-sm font-medium">History</span>
                </>
              )}
            </button>
          )}

          {/* Menu Button - hide when chat history is open */}
          {!chatHistoryOpen && (
            <button
              onClick={toggleMobileMenu}
              className="text-foreground"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? (
                <X className="h-5 w-5" />
              ) : (
                <Menu className="h-5 w-5" />
              )}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
